import { render, staticRenderFns } from "./PerfilAcessoListFilters.vue?vue&type=template&id=7bee3adf&"
import script from "./PerfilAcessoListFilters.vue?vue&type=script&lang=js&"
export * from "./PerfilAcessoListFilters.vue?vue&type=script&lang=js&"
import style0 from "./PerfilAcessoListFilters.vue?vue&type=style&index=0&id=7bee3adf&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports